import { useState } from 'react'
import { Link } from 'react-router-dom'

import '../styles/plans.css'
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import images from '../assets/images'

const Plans = () => {
	const [aActive, setAActive] = useState(false);
	const [bActive, setBActive] = useState(false);
	return (
		<>
			<div className="plans">
				<div className="hdr">
					<h2>Stop guessing. <span>Start winning.</span></h2>
					<h6>AI-powered signals that tell you exactly when to enter and exit.</h6>
					<h4>Choose your <span>plan</span></h4>
					<p>Start trading with AI-powered signals and proven strategies.</p>
				</div>
				<div className="cards">
					<ul>
						<li className='grn'>
							<div className="hdr">
								<h4>BEGINNER SALE <span>68% OFF</span></h4>
							</div>
							<h5>TRADING INDICATOR</h5>
							<div className="img" style={{ backgroundImage: `url(${images.phone1})` }}></div>
							<h3>Summit Capital  Indicator</h3>
							<p className='price'>$78 <span>$25</span></p>
							<div className="bs">
								<p>GET ACCESS TO<span className="grn">BUY</span> AND <span className="red">SELL</span> SIGNALS</p>
								<div className="opt">
									<p className='grn'>BUY</p>
									<p className='red'>SELL</p>
								</div>
								<p>AI tells you exactly where to enter and exit every trade</p>
							</div>
							<ul>
								<li>
									<h4>94.7%</h4>
									<p>accuracy</p>
								</li>
								<li>
									<h4>0.3s</h4>
									<p>alert speed</p>
								</li>
								<li>
									<h4>200+</h4>
									<p>indicators</p>
								</li>
							</ul>
							<div className={'included ' + (aActive ? ' active' : ' ')} onClick={(e) => setAActive(!aActive)}>
								<h5> {aActive ? <IoIosArrowUp /> : <IoIosArrowDown />} WHAT'S INCLUDED {aActive ? <IoIosArrowUp /> : <IoIosArrowDown />} </h5>
								<ul>
									<li>Instant BUY & SELL alerts</li>
									<li>High verified win rate</li>
									<li>Scans 3,200+ markets a second</li>
									<li>0.3s Lightning alert delivery</li>
									<li>Trained on 12 years of data</li>
									<li>TradingView built in</li>
									<li>Multi-timeframe AI analysis</li>
									<li>Auto risk management</li>
									<li>Smart-money & whale tracking</li>
									<li>Sub-second mobile push</li>
									<li>Private trader community</li>
								</ul>
							</div>
							<Link to="/auth" className="btn"><p>Get Indicator Access</p></Link>
						</li>
						<li className='ylw'>
							<div className="hdr">
								<h4>BEGINNER SALE <span>51% OFF</span></h4>
							</div>
							<h5>LIFETIME MEMBERSHIP</h5>
							<div className="img" style={{ backgroundImage: `url(${images.phone3})` }}></div>
							<h3>Lifetime Summit Capital </h3>
							<p className='price'>$3,600 <span>$850</span></p>
							<div className="bs">
								<p>GET ACCESS TO<span className="grn">BUY</span> AND <span className="red">SELL </span> SIGNALS</p>
								<div className="opt">
									<p className='grn'>BUY</p>
									<p className='red'>SELL</p>
								</div>
								<p>AI tells you exactly where to enter and exit every trade</p>
							</div>
							<ul>
								<li>
									<h4>$74M+</h4>
									<p>community generated</p>
								</li>
								<li>
									<h4>95k+</h4>
									<p>members</p>
								</li>
								<li>
									<h4>unlimited</h4>
									<p>updates</p>
								</li>
							</ul>
							<div className={'included ' + (bActive ? ' active' : ' ')} onClick={(e) => setBActive(!bActive)}>
								<h5> {bActive ? <IoIosArrowUp /> : <IoIosArrowDown />} WHAT'S INCLUDED {bActive ? <IoIosArrowUp /> : <IoIosArrowDown />} </h5>
								<ul>
									<li>Pay once. Own it forever</li>
									<li>Everything in the indicator plan</li>
									<li>High VIP members win rate</li>
									<li>Every future upgrade - free</li>
									<li>$74M+ generated by members</li>
									<li>VIP priority signals</li>
									<li>Multi-timeframe AI analysis</li>
									<li>Auto risk management</li>
									<li>Sub-second mobile push</li>
									<li>Runs 24/7, even while you sleep</li>
									<li>Early access to new models</li>
									<li>Founderv-locked pricing</li>
								</ul>
							</div>
							<Link to="/auth" className="btn"><p>Get Indicator Access</p></Link>
						</li>
					</ul>
				</div>
			</div>
		</>
	)
}

export default Plans